var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactanos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2905",
    "data-name": "Group 2905",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.572,
    height: 18,
    viewBox: "0 0 10.572 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 10.572,
    height: 18,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M8.873,18H1.7A1.7,1.7,0,0,1,0,16.3V1.7A1.7,1.7,0,0,1,1.7,0H8.872a1.7,1.7,0,0,1,1.7,1.7V16.3a1.7,1.7,0,0,1-1.7,1.7M1.7.915A.785.785,0,0,0,.915,1.7V16.3a.785.785,0,0,0,.784.784H8.873a.785.785,0,0,0,.784-.784V1.7A.786.786,0,0,0,8.872.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M14.81,49.4a1.109,1.109,0,1,1,1.108-1.11A1.111,1.111,0,0,1,14.81,49.4m0-1.3a.195.195,0,1,0,.194.194.195.195,0,0,0-.194-.194",
    transform: "translate(-9.524 -32.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M12.269,17.36H5.979a.457.457,0,0,1-.457-.457V6.549a.457.457,0,0,1,.457-.457h6.29a.457.457,0,0,1,.457.457V16.9a.457.457,0,0,1-.457.457m-5.833-.915h5.375V7.007H6.437Z",
    transform: "translate(-3.839 -4.235)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactanos);
export default __webpack_public_path__ + "static/media/contactanos.2a96184b064ab24cdc923afd05aa9710.svg";
export { ForwardRef as ReactComponent };